import classNames from "classnames";
import React, { memo, useState } from "react";
import { TaskLifecycleStatus } from "../types";

interface Props {
  value: TaskLifecycleStatus;
  onChange: (status: TaskLifecycleStatus) => void;
}

// api-contract D0.6 / react-frontend-tasks F2 — "All" is removed; default is "Open".
const OPTIONS: { label: string; value: TaskLifecycleStatus }[] = [
  { label: "Open", value: "open" },
  { label: "Completed", value: "completed" },
];

const TaskLifecycleFilter = ({ value, onChange }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedLabel = OPTIONS.find((o) => o.value === value)?.label ?? "Open";

  return (
    <div className="relative inline-block mr-3">
      <button
        type="button"
        className="flex items-center gap-2 px-3 py-2 bg-white border border-black-20 rounded text-13 hover:border-primary"
        onClick={() => setIsOpen((v) => !v)}
        aria-label={`Task status: ${selectedLabel}`}
      >
        <span>{selectedLabel}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 bg-white border border-black-20 rounded shadow-md z-50 w-160 overflow-hidden">
          {OPTIONS.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={classNames(
                "block w-full text-left px-4 py-2 text-13 hover:bg-black-5",
                { "font-semibold text-primary": value === opt.value }
              )}
              onClick={() => {
                onChange(opt.value);
                setIsOpen(false);
              }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(TaskLifecycleFilter);
